module.exports = __webpack_public_path__ + "static/media/logoSvgCapWhite.a560baef.svg";